
export const comite_item = [
    {
        "etica_item_nombre" : "Código de Ética de la Administración Pública del Estado de Hidalgo",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/CodigoEticaAdministracionPublica.pdf"
    },
    {
        "etica_item_nombre" : "Plan Anual de Capacitación 2026",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/ETICA/PROGRAMACAPACITACION.pdf"
    },
    {
        "etica_item_nombre" : "Plan Anual de Trabajo 2026",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/ETICA/PAT2026.pdf"
    },
    {
        "etica_item_nombre" : "Plan Anual de Trabajo 2025",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Etica/PAT2025.pdf"
    },
    {
        "etica_item_nombre" : "Plan Anual de Trabajo 2024",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/PAT2024.pdf"
    },
    {
        "etica_item_nombre" : "Evaluación (UEEPCI) 2024",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/EvaluacionUEEPCI.pdf"
    },
    {
        "etica_item_nombre" : "Código de Conducta 2022-2028",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/CODIGOCONDUCTA.pdf"
    },
    {
        "etica_item_nombre" : "Código de Ética 2022-2028",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/CODIGOETICA.pdf"
    },
    {
        "etica_item_nombre" : "Reglas de Integridad 2022-2028",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/REGLASINTEGRIDAD.pdf"
    },

]
export const etica_item = [
    {
        "etica_item_nombre" : "2023",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/sesion2023.pdf"
    },
    {
        "etica_item_nombre" : "2022",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/sesi%C3%B3n%202022.pdf"
    },
    {
        "etica_item_nombre" : "2021",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/Sesiones%202021.pdf"
    },
    {
        "etica_item_nombre" : "2020",
        "etica_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/Etica/sesi%C3%B3n%202020.pdf"
    },

]
export const mecanismos_item = [
    {
        "mecanismos_item_nombre" : "Mecanismos para dar a conocer el Código de Ética, el Código de Conducta y Reglas de Integridad  Servidores Públicos",
        "mecanismos_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/1.2SADERHCEPCI.pdf"
    },
    {
        "mecanismos_item_nombre" : "Mecanismos para dar a conocer el Código de Ética, el Código de Conducta y Reglas de Integridad  Prestadores de Servicios",
        "mecanismos_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/1.3SADERHCEPCI.pdf"
    },
    {
        "mecanismos_item_nombre" : "Promoción de la integridad y Prevención de Corrupción",
        "mecanismos_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/1.5SADERHCEPCI.pdf"
    },
    {
        "mecanismos_item_nombre" : "Procedimiento para evaluar el Conocimiento y Cumplimiento de los Principios del Código de Ética, el Código de Conducta y Reglas de Integridad",
        "mecanismos_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/1.7SADERHCEPCI.pdf"
    },
    {
        "mecanismos_item_nombre" : "Protocolo de Denuncias",
        "mecanismos_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Etica/ProtocoloDenuncias.pdf"
    },
    {
        "mecanismos_item_nombre" : "Buzón de Denuncias",
        "mecanismos_item_url" : "https://sader.hidalgo.gob.mx/Buzondenuncias"
    },

]